import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';

import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
// @ts-ignore
import  autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'

import rootReducer from './reducers/index';
import rootSaga from './sagas/index';
export const persistConfig = {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel2
};

export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();
const persistedReducer = persistReducer(persistConfig, rootReducer(history))

export default function configureStore() {
    const composeEnhancers = composeWithDevTools({
        // options like actionSanitizer, stateSanitizer
    });
    const store = createStore(
        persistedReducer,
        composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware)),
    );
    const persistor = persistStore(store);

    sagaMiddleware.run(rootSaga);

    return { store, persistor };
}
